// ConeBarn v14

function cbTrack(name, detail) {
  if (window.ConeBarnSiteTools && window.ConeBarnSiteTools.track) {
    window.ConeBarnSiteTools.track(name, detail || {});
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({
    event: name,
    page_path: window.location.pathname
  }, detail || {}));
}

// ── Nav scroll + sticky bar
var nav = document.getElementById('nav');
var sticky = document.getElementById('stickyBar');
var ticking = false;

window.addEventListener('scroll', function() {
  if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
}, { passive: true });

function onScroll() {
  var y = window.scrollY;
  if (nav) nav.classList.toggle('scrolled', y > 40);
  if (sticky) sticky.classList.toggle('show', y > 500);
  ticking = false;
}

// ── Mobile menu
function cbToggleMenu() {
  var menu = document.getElementById('navMenu');
  var burger = document.getElementById('burger');
  if (!menu) return;
  var open = menu.classList.toggle('open');
  if (burger) burger.classList.toggle('open', open);
}
document.querySelectorAll('.cn-nav__links a').forEach(function(a) {
  a.addEventListener('click', function() {
    var menu = document.getElementById('navMenu');
    var burger = document.getElementById('burger');
    if (menu) menu.classList.remove('open');
    if (burger) burger.classList.remove('open');
  });
});

// ── Three-card buy + custom quantity
function cbCardBuy(vid, qty, btn) {
  if (!vid) return;
  var orig = btn ? btn.textContent : '';
  var source = btn && btn.closest('.cn-sticky') ? 'sticky_bar'
    : btn && btn.closest('.cn-nav') ? 'navigation'
    : btn && btn.closest('.cn-custom-qty') ? 'custom_quantity'
    : 'hero_pack_card';
  cbTrack('home_add_to_cart_attempt', {
    variant_id: String(vid),
    quantity: qty,
    source: source
  });
  if (btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: qty }] })
  })
  .then(function(r) { if (!r.ok) throw 0; return r.json(); })
  .then(function() {
    cbTrack('home_add_to_cart_success', {
      variant_id: String(vid),
      quantity: qty,
      source: source
    });
    window.location.href = '/cart';
  })
  .catch(function() {
    cbTrack('home_add_to_cart_error', {
      variant_id: String(vid),
      quantity: qty,
      source: source
    });
    if (btn) { btn.textContent = orig; btn.disabled = false; }
  });
}

function cbCustomBuy(vid, btn) {
  var sel = document.getElementById('customQty');
  if (!sel) return;
  var qty = parseInt(sel.value);
  cbTrack('home_quantity_select', {
    variant_id: String(vid),
    quantity: qty
  });
  if (qty > 0) cbCardBuy(vid, qty, btn);
}

// ── Subscribe toggle
function cbSub(group, mode) {
  var toggle = document.getElementById(group + 'Sub');
  var prices = document.getElementById(group + 'SubPrices');
  if (!toggle || !prices) return;
  var isSub = mode === 'sub';
  cbTrack('home_purchase_mode_select', {
    product_group: group,
    purchase_mode: mode
  });
  toggle.querySelectorAll('.cn-sub__opt').forEach(function(btn, i) {
    btn.classList.toggle('cn-sub__opt--active', isSub ? i === 1 : i === 0);
  });
  prices.classList.toggle('cn-sub-prices--sub', isSub);
}

// ── Add to cart (one-time)
function cbBuy(vid, btn) {
  if (!vid) return;
  var orig = btn ? btn.textContent : '';
  cbTrack('home_product_add_to_cart_attempt', {
    variant_id: String(vid),
    quantity: 1,
    purchase_mode: 'one_time'
  });
  if (btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
  })
  .then(function(r) { if (!r.ok) throw 0; return r.json(); })
  .then(function() {
    cbTrack('home_product_add_to_cart_success', {
      variant_id: String(vid),
      quantity: 1,
      purchase_mode: 'one_time'
    });
    window.location.href = '/cart';
  })
  .catch(function() {
    cbTrack('home_product_add_to_cart_error', {
      variant_id: String(vid),
      quantity: 1,
      purchase_mode: 'one_time'
    });
    if (btn) { btn.textContent = orig; btn.disabled = false; }
  });
}

// ── Add to cart (subscription)
function cbBuySub(vid, spId, btn) {
  if (!vid || !spId) return;
  var orig = btn ? btn.textContent : '';
  cbTrack('home_product_add_to_cart_attempt', {
    variant_id: String(vid),
    quantity: 1,
    purchase_mode: 'subscription',
    selling_plan_id: String(spId)
  });
  if (btn) { btn.textContent = 'Adding\u2026'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1, selling_plan: spId }] })
  })
  .then(function(r) { if (!r.ok) throw 0; return r.json(); })
  .then(function() {
    cbTrack('home_product_add_to_cart_success', {
      variant_id: String(vid),
      quantity: 1,
      purchase_mode: 'subscription',
      selling_plan_id: String(spId)
    });
    window.location.href = '/cart';
  })
  .catch(function() {
    cbTrack('home_product_add_to_cart_error', {
      variant_id: String(vid),
      quantity: 1,
      purchase_mode: 'subscription',
      selling_plan_id: String(spId)
    });
    if (btn) { btn.textContent = orig; btn.disabled = false; }
  });
}

// ── Cost bars animation
var costBarWraps = document.querySelectorAll('.cn-cost__bar');
if (costBarWraps.length) {
  costBarWraps.forEach(function(bar) {
    var fill = bar.querySelector('.cn-cost__fill');
    if (fill) fill.style.width = '0';
  });

  var costObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var fill = entry.target.querySelector('.cn-cost__fill');
        if (fill) fill.style.width = entry.target.style.getPropertyValue('--w');
        costObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

costBarWraps.forEach(function(bar) {
    costObserver.observe(bar);
  });
}

// ── Continuous three-zone review wall
var cbReviewIdx = 0;
var cbReviewTimer = null;
var cbReviewTotal = 0;
var cbReviewVisible = false;

function cbReviewWarmImages() {
  var cards = document.querySelectorAll('.cn-fc__card');
  if (!cards.length) return;

  [cbReviewIdx, (cbReviewIdx + 1) % cards.length].forEach(function(index) {
    var image = cards[index].querySelector('.cn-fc__img');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = index === cbReviewIdx ? 'high' : 'auto';
  });
}

function cbReviewShow(nextIdx) {
  var cards = document.querySelectorAll('.cn-fc__card');
  if (!cards.length) return;

  cbReviewIdx = (nextIdx + cards.length) % cards.length;
  cards.forEach(function(card, idx) {
    var active = idx === cbReviewIdx;
    card.classList.toggle('cn-fc__card--active', active);
    card.setAttribute('aria-hidden', active ? 'false' : 'true');
  });

  var dots = document.querySelectorAll('.cn-fc__dot');
  dots.forEach(function(dot, idx) {
    var active = idx === cbReviewIdx % dots.length;
    dot.classList.toggle('cn-fc__dot--active', active);
    dot.setAttribute('aria-current', active ? 'true' : 'false');
  });

  if (cbReviewVisible) cbReviewWarmImages();
}

function cbReviewStartTimer() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!cbReviewVisible || document.hidden) return;
  if (cbReviewTimer) clearInterval(cbReviewTimer);
  cbReviewTimer = setInterval(function() {
    cbReviewShow((cbReviewIdx + 1) % cbReviewTotal);
  }, 6000);
}

function cbReviewStopTimer() {
  if (!cbReviewTimer) return;
  clearInterval(cbReviewTimer);
  cbReviewTimer = null;
}

function cbReviewNav(dir) {
  cbReviewShow(cbReviewIdx + dir);
  cbReviewWarmImages();
  cbTrack('home_review_change', {
    review_index: cbReviewIdx + 1,
    direction: dir > 0 ? 'next' : 'previous'
  });
  cbReviewStartTimer();
}

function cbReviewPrepareStreams(wall) {
  wall.querySelectorAll('.cn-wall__col').forEach(function(column) {
    var sets = Array.from(column.children).filter(function(child) {
      return child.classList.contains('cn-wall__set');
    });
    if (sets.length !== 1) return;
    var clone = sets[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    column.appendChild(clone);
  });
}

function cbReviewInit() {
  var cards = document.querySelectorAll('.cn-fc__card');
  var dotsEl = document.getElementById('reviewDots');
  var carousel = document.getElementById('reviewCarousel');
  var wall = document.querySelector('.cn-wall');
  if (!cards.length || !dotsEl || !carousel || !wall) return;
  cbReviewTotal = cards.length;
  cbReviewPrepareStreams(wall);

  cards.forEach(function(card, idx) {
    if (idx >= Math.min(cbReviewTotal, 10)) return;
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'cn-fc__dot';
    dot.setAttribute('aria-label', 'Show photo review ' + (idx + 1));
    dot.addEventListener('click', function() {
      cbReviewShow(idx);
      cbTrack('home_review_select', { review_index: idx + 1 });
      cbReviewStartTimer();
    });
    dotsEl.appendChild(dot);
  });

  var startX = 0;
  carousel.addEventListener('touchstart', function(event) {
    startX = event.touches[0].clientX;
  }, { passive: true });
  carousel.addEventListener('touchend', function(event) {
    var diff = event.changedTouches[0].clientX - startX;
    if (Math.abs(diff) > 40) cbReviewNav(diff < 0 ? 1 : -1);
  }, { passive: true });

  carousel.addEventListener('mouseenter', cbReviewStopTimer);
  carousel.addEventListener('mouseleave', cbReviewStartTimer);
  carousel.addEventListener('focusin', cbReviewStopTimer);
  carousel.addEventListener('focusout', cbReviewStartTimer);

  cbReviewShow(0);

  if ('IntersectionObserver' in window) {
    var imageObserver = new IntersectionObserver(function(entries) {
      if (!entries.some(function(entry) { return entry.isIntersecting; })) return;
      cbReviewWarmImages();
      imageObserver.disconnect();
    }, { rootMargin: '800px 0px', threshold: 0 });
    imageObserver.observe(wall);

    var wallObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        cbReviewVisible = entry.isIntersecting;
        wall.classList.toggle('cn-wall--visible', cbReviewVisible);
        if (cbReviewVisible) {
          cbReviewWarmImages();
          cbReviewStartTimer();
        }
        else cbReviewStopTimer();
      });
    }, { threshold: 0.2 });
    wallObserver.observe(wall);
  } else {
    cbReviewVisible = true;
    wall.classList.add('cn-wall--visible');
    cbReviewStartTimer();
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) cbReviewStopTimer();
    else cbReviewStartTimer();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cbReviewInit);
} else {
  cbReviewInit();
}

// ── ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var menu = document.getElementById('navMenu');
    var burger = document.getElementById('burger');
    if (menu) menu.classList.remove('open');
    if (burger) burger.classList.remove('open');
  }
});
